import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-enrichment/utils/nav-context';

const FeedProductPage = lazy(() => import('~/features/catalog-enrichment/pages/feed-product-page'));

/** S8 — `from`/`back`, same as the product page: where a cross-section link sent the user here. */
const searchSchema = z.object({ ...navContextSearchSchema });

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/feed-products/$feedProductId',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { feedProductId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <FeedProductPage feedProductId={feedProductId} />
    </Suspense>
  );
}
